import { render, staticRenderFns } from "./dataInfo.vue?vue&type=template&id=38276fea&scoped=true"
import script from "./dataInfo.vue?vue&type=script&lang=js"
export * from "./dataInfo.vue?vue&type=script&lang=js"
import style0 from "./dataInfo.vue?vue&type=style&index=0&id=38276fea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38276fea",
  null
  
)

export default component.exports